import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const polarisEmbeddedIdeasRoute: InvariantJiraRoute = {
	name: 'polaris-embedded-ideas',
	path: '/jira/polaris/embedded/projects/:projectKey/ideas/view/:resource?',
	query: ['selectedIssue?', 'projectId?'],
	exact: true,
};
